module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-179.8065252.woff2";